import React from 'react';
import classNames from 'classnames';
import { PageProps } from 'gatsby';
import { useStyles } from '@/hooks/useStyles';

const Hamburger: React.FC<
  PageProps<{ active: boolean; onClickButton: () => void }>
> = ({ data }) => {
  const { joinClasses } = useStyles();

  const desktopClasses = {
    container: classNames('bg-primary lg:hidden')
  };
  const mobileClasses = (index?: number) => ({
    container: classNames(
      'p-3 group h-[40px] w-[40px] rounded-full border-2 border-white grid items-center gap-[1px] sm:gap-1'
    ),
    bar: classNames('h-[2px] transition-all duration-500 w-full bg-white', {
      'rotate-45 translate-y-[8px]': data.active && index == 0,
      'scale-x-0': data.active && index == 1,
      '-rotate-45 translate-y-[-6px]': data.active && index == 2
    })
  });

  return (
    <button
      onClick={data.onClickButton}
      className={joinClasses([
        desktopClasses.container,
        mobileClasses().container
      ])}
    >
      {[...Array(3).keys()].map((index) => (
        <span key={index} className={mobileClasses(index).bar}></span>
      ))}
    </button>
  );
};

export default Hamburger;
